export default __webpack_public_path__ + "static/media/website_logo_white.b2a32920.svg";